/** Route guards (PL-03): auth + role gating via react-router. */
import type { AppRole } from '@gym/shared';
import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { CenterSpinner } from '../components/ui/Feedback.js';
import { useAuth } from '../lib/auth.js';

export function RequireAuth(): ReactNode {
  const { session, loading } = useAuth();
  if (loading) return <CenterSpinner />;
  if (!session) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export function RequireRole({ allowed }: { allowed: AppRole[] }): ReactNode {
  const { claims, loading } = useAuth();
  if (loading) return <CenterSpinner />;
  if (!claims || !allowed.includes(claims.app_role)) return <Navigate to="/403" replace />;
  return <Outlet />;
}
